import * as React from "react";
import moment from "moment";

import { DataGrid, Getter } from '../../../../components/DataGrid/DataGrid';
import { DataGridTextColumn } from '../../../../components/DataGrid/DataGridTextColumn';

import { Vehicle, Source } from '../../../../models/Vehicle';
import { DataGridTemplateColumn, Props as TemplateProps } from "../../../../components/DataGrid/DataGridTemplateColumn";
import { Button } from "../../../../components/Buttons";
import { IdColumn } from "../Columns/IdColumn";
import { MultiselectColumn, multiselectPropsFrom, MultiselectProps } from "../Columns/MultiselectColumn";
import { Polyglot } from "../../../../polyglot";
import { Key } from "../../../../models";
import { NonIsolatedPremise } from "../../NonIsolatedPremise";

const getterServiceAccount: Getter<Vehicle> = sa => sa.ServiceAccount;
const getterDivision: Getter<Vehicle> = v => v.Division;
const getterNativeTitle: Getter<Vehicle> = v => v.SourceId === Source.BoxId ? v.BoxId : v.GeotabTitle;
const getterDisplay: Getter<Vehicle> = v => v.Display;
const getterTags: Getter<Vehicle> = v => v.Tags.join(', ');
const getterLastData: Getter<Vehicle> = v => v.LastDataDateTime ? moment(v.LastDataDateTime).format('YYYY-MM-DD HH:mm') : '';

const importIcon = <span className="glyphicon glyphicon-cloud-download" style={{verticalAlign: 'text-bottom'}} />;

interface Props extends MultiselectProps
{
    polyglot: Polyglot;
    isAdmin: boolean;
    isIsolatedPremise: boolean;
    items: Vehicle[];
    sensorsSearchInitiator: Key;
    onEdit: (datum: any, row: number) => void;
    onSensors: (datum: any, row: number) => void;
}

export const VehicleGrid = (props: Props) => (
    <DataGrid initialData={props.items} className={props.className} onThead={props.onThead}>
        <MultiselectColumn {...multiselectPropsFrom(props)} />
        <IdColumn header={props.polyglot.t('column.id')} />
        { !props.isIsolatedPremise && <DataGridTextColumn header={props.polyglot.t('vehicle.label_service_account')} getValue={getterServiceAccount} /> }
        <DataGridTextColumn header={props.polyglot.t('vehicle.label_division')} getValue={getterDivision} />
        <DataGridTemplateColumn header={props.polyglot.t('vehicle.label_native_title')} getValue={getterNativeTitle} render={(colProps: TemplateProps) => {
            const vehicle = colProps.datum as Vehicle;
            return (
                <td>{ vehicle.OngoingAutoImport ? React.cloneElement(importIcon, { title: props.polyglot.t('vehicle.msg_import_in_progress')}) : null } {getterNativeTitle(vehicle)}</td>
            )
        }} />
        <DataGridTextColumn header={props.polyglot.t('vehicle.label_display')} getValue={getterDisplay} />
        <DataGridTextColumn header={props.polyglot.t('vehicle.label_tags')} getValue={getterTags}/>
        <DataGridTextColumn header={props.polyglot.t('vehicle.label_last_data')} getValue={getterLastData} />
        <DataGridTemplateColumn header={props.polyglot.t('column.action')} render={p => {
            const { datum, row } = p;
            const inProgress = (datum as Vehicle).id === props.sensorsSearchInitiator;
            return (
                <td className='btn-toolbar'>
                    { props.isAdmin && <Button dim="xs" leftIcon="pencil" type="info" onClick={e => props.onEdit(datum, row)}>{props.polyglot.t('button.edit_short')}</Button> }
                    <Button dim="xs" type="info" leftIcon="search" spinner={inProgress} disabled={inProgress} onClick={e => props.onSensors(datum, row)}>{props.polyglot.t('vehicle.btn_sensors')}</Button>
                </td>
            );
        }}
        />
    </DataGrid>
);


// WEBPACK FOOTER //
// ./src/app/components/Pages/Vehicle/VehicleGrid.tsx